module.exports = __webpack_public_path__ + "img/IMG_1079.191aa179.png";